import { FC } from "react";
import { useTranslation } from "react-i18next";
import SaleTabPane, { TabProps } from "../../../../components/TabPane";
import CustomerTable from "./components/CustomerTable";
import SDoc from "@/components/SDoc";
import SCustomerPrice from "./components/SCustomerPrice";
import { Customer } from "@/types/sales";
import ShipAddressBook from "./components/ShipAddressBook";

type CustomerTabType = 'price' | 'shipAddress' | 'doc'

const SalesCustomer: FC = () => {
  const { t } = useTranslation();
  const TAB_LIST_KEY = "customer-list"
  const TAB_DOC_KEY = "customer-doc"
  const TAB_PRICE_KEY = "customer-price"
  const TAB_SHIP_ADDRESS_KEY = "customer-ship-address"

  const keyObj: (customer: Customer) => { [key in CustomerTabType]: TabProps } = (customer) => ({
    doc: {
      key: TAB_DOC_KEY,
      label: (customer.shortName || customer.code) + ' ' + t('sale.documents'),
      children: <SDoc docId={customer.docId} />
    },
    price: {
      key: TAB_PRICE_KEY,
      label: (customer.shortName || customer.code) + ' ' + t('sale.priceDetail'),
      children: <SCustomerPrice customer={customer} />,
    },
    shipAddress: {
      key: `${TAB_SHIP_ADDRESS_KEY}-${customer.id}`,
      label: (customer.shortName || customer.code) + ' ' + t('sale.shipAddressBook'),
      children: <ShipAddressBook customer={customer} />,
    },
  })

  return <SaleTabPane<Customer> defaultKey={TAB_LIST_KEY} defaultTabs={[
    {
      key: TAB_LIST_KEY,
      label: t("sale.customerList"),
      children: <CustomerTable />,
      closable: false,
    },
  ]} onOpens={(info) => keyObj(info)} />
}

export default SalesCustomer;
